import SideBarContext from "../../contexts/side-bar-context";
import { useContext } from "react";
import ActionIcon from "./action-icon";
import { History } from "lucide-react";
import { getCommandKey } from "../../lib/utils";

const ToggleHistory = ({ additionalclasses, size, tip, color }) => {
  const { toggleChatHistory, isChatHistory } = useContext(SideBarContext);

  return (
    <div
      onClick={toggleChatHistory}
      className={`relative rounded-[8px] transtion-all duration-300 w-fit cursor-pointer`}
    >
      <ActionIcon
        position={tip || "right"}
        command={`${getCommandKey("⌘", "Ctrl")} + H `}
        content={` ${isChatHistory ? "Close" : "Open"} chat history`}
        color={`custom-text-grey-800 ${color}`}
      >
        <History size={size} color="currentColor" />
      </ActionIcon>
    </div>
  );
};

export default ToggleHistory;
